import { UntypedFormGroup } from '@angular/forms';
import { LoginAuthWithCredentialsReturnObj } from '@com-delta-idp/mnx-oauth';
import { LoginFooterData } from '../../../shared/login-footer/modals/login-footer.interface';

export interface LoginCredentialContent {
  footer: LoginFooterData;
  skyMilesLabel?: string;
  srText?: string;
  forgotPasswordText: string;
  headerSubTitle: string;
  headerTitle: string;
  isExternalResetPassword: string;
  keepMeLoggedInLabel: string;
  keepMeLoggedInToolTipMsg: string;
  lastNameLabel: string;
  lastNameText: string;
  nextDisplayView: NextDisplayView;
  passwordLabel: string;
  passwordText: string;
  srOnlyText: string;
  toolTipImage: string;
  userIdLabel: string;
  userIdText: string;
  viewName: string;
  pageHeader: PageHeader;
  errors: LoginErrorMessages;
  buttonLabel?: string;
  mfaSuccess?: boolean;
}

export interface PageHeader {
  altText: string;
  logoUrl: string;
  headerTitle: string;
  headerSubTitle: string;
  contentBodyHeader?: string;
  enterPasswordText?: string;
}

export interface ErrorMessage {
  errorId: string;
  errorMessageDescription: string;
  errorMessageTitle: string;
}

export interface Errors {
  errorMessages: ErrorMessage[];
}
export interface AnalyticsData {
  action: string;
  eventDetails?: string;
  startTime?: number;
  errorCode?: string;
  errorMessage?: string;
}
export interface NextDisplayView {
  button_continue: string;
  button_createPassword: string;
  button_forgotPassword: string;
  button_loginHelp: string;
  button_modal: string;
  button_resetPassword: string;
  button_sendLogin: string;
  button_wfp: string;
  nextViewName: string;
  nextViewName_createPassword: string;
  nextViewName_email: string;
  nextViewName_forgotPassword: string;
  nextViewName_loginHelp: string;
  nextViewName_resetPassword: string;
  nextViewName_sendLogin: string;
  nextViewName_sqa: string;
  overlayMessage: string;
  refreshUrl: string;
}
export interface LoginContent {
  formGroup: UntypedFormGroup;
  loginFormAttributes: LoginFormAttributes;
  pageContent: LoginCredentialContent;
  authenticationEnabled: LoginAuthWithCredentialsReturnObj;
  errorCode?: string;
  errorMessage?: string;
  disableButton?: boolean;
  skyMilesNumber?: string;
}

export interface LoginErrorMessages {
  usernameErrorMessage: string;
  passwordErrorMessage: string;
  lastNameErrorMessage: string;
  alertWarning: string;
}

export interface LoginFormAttributes {
  errorCount: number;
  submitAttempt?: boolean;
  errorAlertBanner: boolean;
  isLastNameRequired: boolean;
  formAlertSuccessIcon: boolean;
  userIdControlTouched: boolean;
  passwordControlTouched: boolean;
  lastNameControlTouched: boolean;
  keepMeLoggedInTouched: boolean;
}

export interface HelpModal {
  icon: boolean;
  title: string;
  content: string;
  type: string;
}

export interface LoginAuthenticationScreen {
  formGroup: UntypedFormGroup;
  loginFormAttributes: LoginFormAttributes;
  pageContent: LoginCredentialContent;
  authenticationEnabled: LoginAuthWithCredentialsReturnObj;
  errorCode?: string;
  errorMessage?: string;
  disableButton?: boolean;
}
export interface LoginAuthUserInputFields {
  userName: string;
  password: string;
  lastName?: string;
  persistentLogin?: string;
  rememberMe?: string;
}
